import {
  Pagination,
  PropertyGridList,
} from "../components/common/page-components";
import { property } from "../data/dummyData";

const Property = () => {
  return (
    <div className="pt-20 px-[3%] md:px-[6%]">
      <PropertyGridList textLength={120} showLabels />
      <Pagination itemsPerPage={6} pageData={property} />
    </div>
  );
};

export default Property;
